import SEO from '../components/seo';
import Wrapper from '../layout/wrapper';
import MeusPagamentosMain from '../components/meus-pagamentos';

const MeusPagamentos = () => {
  return (
    <Wrapper>
      <SEO pageTitle={'Meus Pagamentos'} />
      <MeusPagamentosMain/>
    </Wrapper>
  );
};

export default MeusPagamentos;